export const pictureUrl = (picture) => {
  if (!picture) return "";
  if (picture.startsWith("http")) return picture;
  return `https://signup-extension-data.s3.amazonaws.com/images/${picture}`;
};

export const thumbnailUrl = (id) => {
  return `https://signup-extension-data.s3.amazonaws.com/thumbnails/${id}.png`;
};
